module.exports = __webpack_public_path__ + "static/media/MobileLightMode.193f38d1.png";